import infrastrukturListeFields from '@/config/infrastruktur/infrastrukturListeFields';
import standortApi from '@/services/api/v1/infrastruktur/standort/index';
import gruppeApi from '@/services/api/v1/infrastruktur/gruppe';
import { IT } from '@/constants/infrastruktur/assetgruppe.type';

export default [
  {
    path: 'infrastrukturverwaltung',
    component: () => import('@/layouts/infrastrukturverwaltung/Infrastrukturverwaltung.vue'),
    children: [
      {
        name: 'infrastrukturverwaltung',
        path: '',
        component: () => import('@/views/infrastrukturverwaltung/InfrastrukturverwaltungStartseite.vue'),
      },
      {
        name: 'infrastrukturliste',
        path: 'infrastruktur',
        component: () => import('@/views/infrastrukturverwaltung/infrastruktur/Infrastrukturliste.vue'),
        props: {
          canAdd: true,
          additionalFields: infrastrukturListeFields.stammliste,
        },
      },
      {
        name: 'infrastrukturliste.kategorie',
        path: 'infrastruktur/kategorie/:kategorie',
        component: () => import('@/views/infrastrukturverwaltung/infrastruktur/Infrastrukturliste.vue'),
        props: (route) => ({
          canAdd: true,
          additionalFields: infrastrukturListeFields.stammliste,
          kategorie: route.params.kategorie,
        }),
      },
      {
        name: 'infrastrukturliste.kategorie.pruefungwartung',
        path: 'infrastruktur/kategorie/:kategorie/pruefung-wartung',
        component: () => import('@/views/infrastrukturverwaltung/infrastruktur/Infrastrukturliste.vue'),
        props: (route) => ({
          canAdd: false,
          additionalFields: infrastrukturListeFields.pruefungWartungFields,
          kategorie: route.params.kategorie,
          pruefungWartung: true,
        }),
      },
      {
        name: 'infrastrukturliste.kategorie.status',
        path: 'infrastruktur/kategorie/:kategorie/status/:status',
        component: () => import('@/views/infrastrukturverwaltung/infrastruktur/Infrastrukturliste.vue'),
        props: (route) => ({
          canAdd: false,
          additionalFields: infrastrukturListeFields.pruefungWartungFields,
          kategorie: route.params.kategorie,
          status: route.params.status,
        }),
      },
      {
        name: 'infrastruktur.neu.tab',
        path: 'infrastruktur/neu/:primarytab/:tab',
        component: () => import('@/views/infrastrukturverwaltung/infrastruktur/Infrastruktur.vue'),
        props: (route) => ({
          id: null,
          edit: true,
          tab: route.params.tab,
          primarytab: route.params.primarytab,
        }),
      },
      {
        name: 'infrastruktur.neu',
        path: 'infrastruktur/neu',
        component: () => import('@/views/infrastrukturverwaltung/infrastruktur/Infrastruktur.vue'),
        props: {
          id: null,
          edit: true,
        },
      },
      {
        name: 'infrastruktur.id',
        path: 'infrastruktur/:id',
        component: () => import('@/views/infrastrukturverwaltung/infrastruktur/Infrastruktur.vue'),
        props: (route) => ({
          id: route.params.id,
          edit: false,
        }),
      },
      {
        name: 'infrastruktur.id.edit',
        path: 'infrastruktur/:id/edit',
        component: () => import('@/views/infrastrukturverwaltung/infrastruktur/Infrastruktur.vue'),
        props: (route) => ({
          id: route.params.id,
          edit: true,
        }),
      },
      {
        name: 'infrastruktur.id.tab',
        path: 'infrastruktur/:id/:tab',
        component: () => import('@/views/infrastrukturverwaltung/infrastruktur/Infrastruktur.vue'),
        props: (route) => ({
          id: route.params.id,
          edit: false,
          tab: route.params.tab,
        }),
      },
      {
        name: 'infrastruktur.id.edit.tab',
        path: 'infrastruktur/:id/:tab/edit',
        component: () => import('@/views/infrastrukturverwaltung/infrastruktur/Infrastruktur.vue'),
        props: (route) => ({
          id: route.params.id,
          edit: true,
          tab: route.params.tab,
        }),
      },
      {
        path: 'settings',
        component: () => import('@/layouts/infrastrukturverwaltung/Settings.vue'),
        children: [
          {
            path: 'standorte',
            name: 'infrastruktur.settings.standorte',
            component: () => import('@/views/infrastrukturverwaltung/settings/Kategorien.vue'),
            props: {
              title: 'Standorte',
              api: standortApi,
              name: 'Standort',
              moduleScope: 'administrative_rights',
              nameMitArtikel: 'den Standort',
              allowEditRootLevel: true, // Allow adding root-level locations
            },
          },
          {
            path: 'kategorien',
            name: 'infrastruktur.settings.kategorien',
            component: () => import('@/views/infrastrukturverwaltung/settings/Kategorien.vue'),
            props: () => ({
              title: 'Kategorien',
              api: gruppeApi,
              name: 'Kategorie',
              moduleScope: 'administrative_rights',
              nameMitArtikel: 'die Kategorie',
              allowEditRootLevel: false,
              excludeIds: [IT], // Pass excludeIds as an array if provided in query params
            }),
          },
        ],
      },
    ],
  },
];
